var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtvPanasonicStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.11875V12.125H6.25H7.5V10.9437V9.76875L8.55 9.73125C9.99375 9.68125 10.5625 9.51875 11.175 8.96875C11.6938 8.5 12 7.74375 12 6.89375C12 5.825 11.5625 5 10.7688 4.575C10.0063 4.175 9.95 4.16875 7.3625 4.1375L5 4.11875V8.11875ZM9.23125 6.20625C9.55625 6.375 9.6875 6.6 9.6875 6.9625C9.6875 7.55625 9.36875 7.7375 8.24375 7.79375L7.5 7.83125V6.9375V6.05L8.26875 6.075C8.81875 6.09375 9.0875 6.13125 9.23125 6.20625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtvPanasonicStore);
export default __webpack_public_path__ + "static/media/ctv_panasonic_store.f596e1eef439f21105c5b5bb13cd1ee1.svg";
export { ForwardRef as ReactComponent };